import { render, staticRenderFns } from "./VerifyABDM.vue?vue&type=template&id=19d57bec"
import script from "./VerifyABDM.vue?vue&type=script&lang=js"
export * from "./VerifyABDM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports